<template>
    <div>
        <WarningNotification v-if="row.Balance > 0">
            <template #header>
                Your tenancy is in arrears by &pound;{{ row.Balance | currency }}.
            </template>
            <template #main>
                <p class="is-size-7">
                    If you haven't already, please pay your outstanding balance.
                </p>
                <p v-if="$meta.features.tenants.bank_account || $meta.features.tenants.online_payments">
                    <b-button
                        type="is-warning"
                        inverted
                        outlined
                        rounded
                        @click.prevent="showModal()"
                    >
                        Pay
                    </b-button>
                </p>
            </template>
        </WarningNotification>
    </div>
</template>

<script>
import WarningNotification from './WarningNotification.vue';
import PaymentModal from './PaymentModal.vue';

export default {
    components: {
        WarningNotification,
    },

    props: {
        row: {
            type: Object,
            required: true,
        }
    },

    methods: {
        showModal() {
            this.$buefy.modal.open({
                parent: this,
                component: PaymentModal,
                hasModalCard: true,
                props: {
                    balance: this.row.Balance,
                    link: {
                        name: 'tenancy-property-pay',
                        params: {
                            id: this.row.TenancyFK,
                        },
                    },
                },
            });
        },
    },
};
</script>
